import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';
import users from '../../../../users';
import { validationMixin } from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';

export default {
  name: 'connectionFeeCalculator',
  mixins: [users, validationMixin],
  components: {
    TreeSelect: require('../../../../customcontrols/selectOfTree.vue').default,
  },
  validations: {
    dataObj: {
      appData: {
        bedroomArea: {
          minValue: minValue(0)
        },
        netBuildingArea: {
          minValue: minValue(0)
        },
        buildingArea: {
          minValue: minValue(0)
        },
        connLength: {
          minValue: minValue(0)
        },
        connLength1: {
          minValue: minValue(0)
        },
        connLength2: {
          minValue: minValue(0)
        },
        depth: {
          minValue: minValue(0)
        },
        gardenArea: {
          minValue: minValue(0)
        }/*not used*/,
        illegalAmount: {
          minValue: minValue(0)
        },
        illegalNoMonths: {
          minValue: minValue(0)
        },
        instrWaterAmount: {
          minValue: minValue(0)
        },
        landFloorArea: {
          minValue: minValue(0)
        }/*not used*/,
        noFloors: {
          minValue: minValue(0)
        },
        noRooms: {
          minValue: minValue(0)
        }/*not used*/,
        pipeLength: {
          minValue: minValue(0)
        },
        repeatedFloorArea: {
          minValue: minValue(0)
        }/*not used*/,
        roofRoomArea: {
          minValue: minValue(0)
        },
        spaceArea: {
          minValue: minValue(0)
        },
        swimPoolArea: {
          minValue: minValue(0)
        },
        installmentsData: {
          installmentAmount: {
            required,
            minValue: minValue(0)
          },
          numberOfInstallments: {
            required,
            minValue: minValue(0)
          },
          initialAmount: {
            required,
            minValue: minValue(0)
          },
          chargeMonth: {
            required,
            minValue: minValue(1)
          },
          chargeDay: {
            required,
            minValue: minValue(1)
          },
          penaltyValue: {
            minValue: minValue(0)
          }
        },
      }
    },
    newUnit: {
      noUnit: {
        minValue: minValue(0.1)
      },
      connectionTypeId: {
        required,
      },
      connDiamId: {
        required,
      },
      unitArea: {
        required,
        minValue: minValue(0.1)
      },
      floorNoId: {
        required,
      },
      roomsQuantity: {
        minValue: minValue(0)
      },
      illegalId: {
        required,
      },
    },
    units: {
      $each: {
        noUnit: {
          required,
          minValue: minValue(1)
        },
        connectionTypeId: {
          required,
        },
        connDiamId: {
          required,
        },
        unitArea: {
          required,
          minValue: minValue(0.1)
        },
        floorNoId: {
          required,
        },
        roomsQuantity: {
          minValue: minValue(0)
        },
        illegalId: {
          required,
        },
      }
    },
    newTool: {
      toolId: {
        required
      },
      quantity: {
        required,
        minValue: minValue(0.1)
      }
    },
    selectFee: {
      mainItem: {
        required,
        minValue: minValue(0)
      },
      subItem: {
        required
      },
      actualCost: {
        required,
        minValue: minValue(0.01)
      },
      numberOfUnits: {
        required,
        minValue: minValue(1)
      }
    }
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      currentTab: '',
      list: [],
      item: '',
      addUnitDialogShow: false,
      deleteUnitConfirmationDialogShow: false,
      addToolDialogShow: false,
      deleteToolConfirmationDialogShow: false,
      tools: [],
      tool: null,
      newUnit: {
        applicationId: 0,
        activityAppKey: 0,
        orderId: 0,
        noUnit: 1,
        unitArea: null,
        floorNoId: null,
        connectionTypeId: null,
        connDiamId: null,
        roomsQuantity: null,
        hasSewer: null,
        hasWater: true,
        illegalId: null
      },
      deletedUnitIdx: -1,
      newTool: {
        applicationId: 0,
        activityAppKey: 0,
        orderId: 0,
        name: '',
        unitPrice: 1,
        vat: 0,
        admin: 0,
        adminVat: false,
        install: 0,
        quantity: 1,
        amount: 0,
        vatAmount: 0,
        adminAmount: 0,
        adminVatAmount: 0,
        installAmount: 0,
        onlyAdminFees: false,
        totalAmount: 0,
        toolId: 0
      },
      deleteToolIndex: -1,
      totalCharges: 0,

      selectFee: {
        mainItem: null,
        subItem: '0',
        actualCost: 0,
        numberOfUnits: 1
      },
      installmentDescribe: '',
      selectedPenaltyType: 0,
      selectedPenaltyValue: 0,
      installmentsPenaltyValues: [],
    }
  },
  computed: {
    units() {
      return this.dataObj.appData.units;
    },
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('view_charges_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = Number(this.dataObj.appId);

        if (this.dataObj.service == 0) {
          this.currentTab = 'tab-generalData_water';
        }
        else if (this.dataObj.service == 1) {
          this.currentTab = 'tab-generalData_sewer';
        }

        this.fillTools();

        this.prepareInstallments();
        console.log('dataObj', this.dataObj);
      });
    },
    fillTools() {
      for (var i = 0; i < this.dataObj.calculatorTools.length; i++) {
        this.tools.push({
          id: this.dataObj.calculatorTools[i].toolId,
          label: this.dataObj.calculatorTools[i].name,
          admin: this.dataObj.calculatorTools[i].admin,
          adminVat: this.dataObj.calculatorTools[i].adminVat,
          install: this.dataObj.calculatorTools[i].install,
          unitPrice: this.dataObj.calculatorTools[i].unitPrice,
          vat: this.dataObj.calculatorTools[i].vat,
        });
      }
    },
    changeTab(e) {
      this.currentTab = e;
    },
    getValidationClass(data, objName) {
      const field = this.$v[data][objName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    getValidationClass2(data, objName, objField) {
      const field = this.$v[data][objName][objField];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    getValidationClass3(data, objName, objField, obj4) {
      const field = this.$v[data][objName][objField][obj4];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    addUnit() {
      this.newUnit = {
        applicationId: this.dataObj.appId,
        activityAppKey: this.dataObj.appKey,
        orderId: this.dataObj.appData.units.length,
        noUnit: 1,
        unitArea: null,
        floorNoId: null,
        connectionTypeId: null,
        roomsQuantity: null,
        hasSewer: this.dataObj.service == 0 ? false : false,
        hasWater: this.dataObj.service == 0 ? true : false,
        illegalId: null
      };

      //this.posts.unshift(post);
      this.dataObj.appData.units.unshift(this.newUnit);

      /*this.$v.newUnit.$reset();

      this.addUnitDialogShow = true;*/
    },
    saveNewUnit() {
      this.$v.newUnit.$touch();

      if (this.$v.newUnit.$invalid) {
        return;
      }

      if (this.newUnit.hasSewer == null) {
        this.newUnit.hasSewer = false;
      }

      if (this.newUnit.hasWater == null) {
        this.newUnit.hasWater = false;
      }

      if (this.newUnit.roomsQuantity == null) {
        this.newUnit.roomsQuantity = 0;
      }

      this.dataObj.appData.units.push(this.newUnit);
      this.addUnitDialogShow = false;
    },
    deleteUnitConfirmation(unitIdx) {
      this.deletedUnitIdx = unitIdx;
      this.deleteUnitConfirmationDialogShow = true;
    },
    deleteUnit() {
      this.dataObj.appData.units.splice(this.deletedUnitIdx, 1);
      this.deleteUnitConfirmationDialogShow = false;
      //this.reOrderUnits();
    },
    addTool() {
      this.newTool = {
        applicationId: this.appId,
        activityAppKey: this.dataObj.appKey,
        orderId: 0,
        name: '',
        unitPrice: 1,
        vat: 0,
        admin: 0,
        adminVat: false,
        install: 0,
        quantity: 1,
        amount: 0,
        vatAmount: 0,
        adminAmount: 0,
        adminVatAmount: 0,
        installAmount: 0,
        onlyAdminFees: false,
        totalAmount: 0
      };

      this.addToolDialogShow = true;
    },
    saveNewTool() {
      //var t = this.dataObj.calculatorTools.filter(a => a.toolId == this.newTool.toolId)[0];

      //this.newTool.name = t.name;
      //this.newTool.unitPrice = Number(t.unitPrice).toFixed(2);
      //this.newTool.vat = Number(t.vat).toFixed(2);
      //this.newTool.admin = Number(t.admin).toFixed(2);
      //this.newTool.adminVat = Number(t.adminVat).toFixed(2);
      //this.newTool.install = Number(t.install).toFixed(2);
      //this.newTool.quantity = this.newTool.quantity == '' ? 1 : Number(this.newTool.quantity);
      //this.newTool.amount = (t.unitPrice * Number(this.newTool.quantity)).toFixed(2);
      //this.newTool.vatAmount = (Number(this.newTool.amount) * t.vat / 100).toFixed(2);
      //this.newTool.adminAmount = (Number(this.newTool.amount) * t.admin / 100).toFixed(2);
      //this.newTool.adminVatAmount = (Number(this.newTool.adminAmount) * t.adminVat / 100).toFixed(2);
      //this.newTool.installAmount = (t.install * Number(this.newTool.quantity)).toFixed(2);

      //var total = this.newTool.onlyAdminFees == false ?
      //  (Number(this.newTool.amount) + Number(this.newTool.vatAmount) + Number(this.newTool.adminAmount) + Number(this.newTool.adminVatAmount) + Number(this.newTool.installAmount)) :
      //  (Number(this.newTool.adminAmount) + Number(this.newTool.adminVatAmount) + Number(this.newTool.installAmount));

      //this.newTool.totalAmount = total.toFixed(2);

      //axios.post('/ConnectionFeeCalculatorActivity/RoundTool', this.newTool)
      //  .then(response => {
      //    if (response.status == 200) {
      //      console.log('ConnectionFeeCalculatorActivity/RoundTool', response);
      //    }
      //    else
      //      this.$alertMsg(response.data.data.text);
      //  })
      //  .catch(err => {
      //    this.$alertMsg(err.response.data);
      //  });

      this.$v.newTool.$touch();

      if (this.$v.newTool.$invalid) {
        return;
      }

      var t = this.dataObj.calculatorTools.filter(a => a.toolId == this.newTool.toolId)[0];

      this.newTool.orderId = this.dataObj.appData.tools.length + 1;
      this.newTool.name = t.name;
      this.newTool.unitPrice = Number(t.unitPrice).toFixed(2);
      this.newTool.vat = Number(t.vat).toFixed(2);
      this.newTool.admin = Number(t.admin).toFixed(2);
      this.newTool.adminVat = Number(t.adminVat).toFixed(2);
      this.newTool.install = Number(t.install).toFixed(2);
      this.newTool.quantity = this.newTool.quantity == '' ? 1 : Number(this.newTool.quantity);
      this.newTool.amount = (t.unitPrice * Number(this.newTool.quantity)).toFixed(2);
      
      this.newTool.installAmount = (t.install * Number(this.newTool.quantity)).toFixed(2);

      //this.newTool.vatAmount = (Number(this.newTool.amount) * t.vat / 100).toFixed(2);
      //this.newTool.adminAmount = (Number(this.newTool.amount) * t.admin / 100).toFixed(2);
      //this.newTool.adminVatAmount = (Number(this.newTool.adminAmount) * t.adminVat / 100).toFixed(2);

      var n = Number(this.newTool.amount) + Number(this.newTool.installAmount);
      this.newTool.adminAmount = (Number(n) * t.admin / 100).toFixed(2);
      this.newTool.adminVatAmount = (Number(this.newTool.adminAmount) * t.adminVat / 100).toFixed(2);

      var amountVat = this.newTool.onlyAdminFees ? 0 : (Number(this.newTool.amount) * t.vat / 100).toFixed(2);
      var insVat = (Number(this.newTool.installAmount) * t.vat / 100).toFixed(2);

      this.newTool.vatAmount = (Number(amountVat) + Number(insVat)).toFixed(2);
      
      var total = this.newTool.onlyAdminFees == false ?
        (Number(this.newTool.amount) + Number(this.newTool.vatAmount) + Number(this.newTool.adminAmount) + Number(this.newTool.adminVatAmount) + Number(this.newTool.installAmount)) :
        (Number(this.newTool.adminAmount) + Number(this.newTool.adminVatAmount) + Number(this.newTool.installAmount) + Number(this.newTool.vatAmount));

      this.newTool.totalAmount = total.toFixed(2);

      this.dataObj.appData.tools.push(this.newTool);
      this.addToolDialogShow = false;
    },
    deleteToolConfirmation(index) {
      console.log(index);
      this.deleteToolIndex = index;
      this.deleteToolConfirmationDialogShow = true;
    },
    deleteTool() {
      this.dataObj.appData.tools.splice(this.deleteToolIndex, 1);
      this.deleteToolConfirmationDialogShow = false;
      this.reOrderTools();
    },
    reOrderTools() {
      for (var i = 0; i < this.dataObj.appData.tools.length; i++) {
        this.dataObj.appData.tools[i].orderId = i + 1;
      }
    },
    reOrderUnits() {
      for (var i = 0; i < this.dataObj.appData.units.length; i++) {
        this.dataObj.appData.units[i].orderId = i + 1;
      }
    },
    validateAppData() {
      var installmentCheck = true;
      var mainDataCheck = true;
      var unitsCheck = true;

      this.$v.dataObj.appData.bedroomArea.$touch();
      this.$v.dataObj.appData.netBuildingArea.$touch();
      this.$v.dataObj.appData.buildingArea.$touch();
      this.$v.dataObj.appData.connLength.$touch();
      this.$v.dataObj.appData.connLength1.$touch();
      this.$v.dataObj.appData.connLength2.$touch();
      this.$v.dataObj.appData.depth.$touch();
      this.$v.dataObj.appData.gardenArea.$touch();
      this.$v.dataObj.appData.illegalAmount.$touch();
      this.$v.dataObj.appData.illegalNoMonths.$touch();
      this.$v.dataObj.appData.instrWaterAmount.$touch();
      this.$v.dataObj.appData.landFloorArea.$touch();
      this.$v.dataObj.appData.noFloors.$touch();
      this.$v.dataObj.appData.noRooms.$touch();
      this.$v.dataObj.appData.pipeLength.$touch();
      this.$v.dataObj.appData.repeatedFloorArea.$touch();
      this.$v.dataObj.appData.roofRoomArea.$touch();
      this.$v.dataObj.appData.spaceArea.$touch();
      this.$v.dataObj.appData.swimPoolArea.$touch();
      this.$v.dataObj.appData.spaceArea.$touch();
      this.$v.dataObj.appData.swimPoolArea.$touch();
      
      this.$v.units.$touch();

      if (this.$v.dataObj.appData.bedroomArea.$invalid ||
        this.$v.dataObj.appData.netBuildingArea.$invalid ||
        this.$v.dataObj.appData.buildingArea.$invalid ||
        this.$v.dataObj.appData.connLength.$invalid ||
        this.$v.dataObj.appData.connLength1.$invalid ||
        this.$v.dataObj.appData.connLength2.$invalid ||
        this.$v.dataObj.appData.depth.$invalid ||
        this.$v.dataObj.appData.gardenArea.$invalid ||
        this.$v.dataObj.appData.illegalAmount.$invalid ||
        this.$v.dataObj.appData.illegalNoMonths.$invalid ||
        this.$v.dataObj.appData.instrWaterAmount.$invalid ||
        this.$v.dataObj.appData.landFloorArea.$invalid ||
        this.$v.dataObj.appData.noFloors.$invalid ||
        this.$v.dataObj.appData.noRooms.$invalid ||
        this.$v.dataObj.appData.pipeLength.$invalid ||
        this.$v.dataObj.appData.repeatedFloorArea.$invalid ||
        this.$v.dataObj.appData.roofRoomArea.$invalid ||
        this.$v.dataObj.appData.spaceArea.$invalid ||
        this.$v.dataObj.appData.swimPoolArea.$invalid ||
        this.$v.dataObj.appData.spaceArea.$invalid ||
        this.$v.dataObj.appData.swimPoolArea.$invalid
        ) {
        this.currentTab = this.dataObj.service == 0 ? 'tab-generalData_water' : 'tab-generalData_sewer';
        mainDataCheck = false;
      }

      if (this.$v.units.$invalid) {
        this.currentTab = 'tab-units';
        unitsCheck = false;
      }

      for (var i = 0; i < this.dataObj.appData.units.length; i++) {
        this.dataObj.appData.units[i].hasSewer = this.dataObj.appData.units[i].hasSewer == null ? false : this.dataObj.appData.units[i].hasSewer;
        this.dataObj.appData.units[i].hasWater = this.dataObj.appData.units[i].hasWater == null ? false : this.dataObj.appData.units[i].hasWater;
        this.dataObj.appData.units[i].noUnit = Number(this.dataObj.appData.units[i].noUnit);
        this.dataObj.appData.units[i].roomsQuantity = this.dataObj.appData.units[i].roomsQuantity == null ? 0 : Number(this.dataObj.appData.units[i].roomsQuantity);
        this.dataObj.appData.units[i].unitArea = Number(this.dataObj.appData.units[i].unitArea);
      }

      if (this.dataObj.appData.allowInstallments) {


        if (this.dataObj.appData.installmentsData.installmentMethod == 0) {
          this.$v.dataObj.appData.installmentsData.installmentAmount.$touch();

          if (this.$v.dataObj.appData.installmentsData.installmentAmount.$invalid)
            installmentCheck = false;
        }
        else if (this.dataObj.appData.installmentsData.installmentMethod == 1) {
          this.$v.dataObj.appData.installmentsData.numberOfInstallments.$touch();

          if (this.$v.dataObj.appData.installmentsData.numberOfInstallments.$invalid)
            installmentCheck = false;
        }

        this.$v.dataObj.appData.installmentsData.initialAmount.$touch();
        if (this.$v.dataObj.appData.installmentsData.initialAmount.$invalid)
          installmentCheck = false;

        this.$v.dataObj.appData.installmentsData.penaltyValue.$touch();
        if (this.$v.dataObj.appData.installmentsData.penaltyValue.$invalid)
          installmentCheck = false;

        if (this.dataObj.appData.installmentsData.chargeSchedule == 0) {
          this.$v.dataObj.appData.installmentsData.chargeMonth.$touch();
          this.$v.dataObj.appData.installmentsData.chargeDay.$touch();

          if (this.$v.dataObj.appData.installmentsData.chargeMonth.$invalid || this.$v.dataObj.appData.installmentsData.chargeDay.$invalid)
            installmentCheck = false;
        }

        if (!installmentCheck)
          this.currentTab = 'tab-installments';
      }

      console.log('aaaaaaaaaaaaaaaaa');
      console.log(installmentCheck);
      console.log(mainDataCheck);
      console.log(unitsCheck);

      if (installmentCheck && mainDataCheck && unitsCheck)
        return true;
      else
        return false;
    },
    getValidationClassUnits(fieldName, index) {
      const field = this.$v.units.$each[index][fieldName];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    getValidationClassTools(fieldName, index) {
      const field = this.$v.toolsValidation.$each[index][fieldName];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    moveUnitUp(idx) {
      if (idx == 0)
        return;

      this.dataObj.appData.units.splice(idx - 1, 0, this.dataObj.appData.units.splice(idx, 1)[0]);
    },
    moveUnitDown(idx) {
      if (idx == this.dataObj.appData.units.length - 1)
        return;

      this.dataObj.appData.units.splice(idx + 1, 0, this.dataObj.appData.units.splice(idx, 1)[0]);
    },
    calculateCharges() {
      if (this.dataObj.appData.cement == null) {
        this.dataObj.appData.cement = 0;
      }
      else {
        this.dataObj.appData.cement = this.dataObj.appData.cement == true ? 1 : 0;
      }

      for (var i = 0; i < this.dataObj.appData.units.length; i++) {
        this.dataObj.appData.units[i].applicationId = Number(this.dataObj.appData.units[i].applicationId);
        this.dataObj.appData.units[i].unitArea = Number(this.dataObj.appData.units[i].unitArea);
        this.dataObj.appData.units[i].roomsQuantity = Number(this.dataObj.appData.units[i].roomsQuantity);
        this.dataObj.appData.units[i].hasSewer = this.dataObj.appData.units[i].hasSewer == null ? false : this.dataObj.appData.units[i].hasSewer;
      }

      var parameter = this.dataObj.parent.activityParameters(
        this.dataObj.appId, this.dataObj.appKey, false,
        [
          { key: 'SaveCustomFields', value: true },
          { key: 'Item', value: JSON.parse(JSON.stringify(this.dataObj.appData)) }
        ]
      );

      this.dataObj.parent.savingTask = true;
      axios.post('/ConnectionFeeCalculatorActivity/SetData', parameter)
        .then(resp => {
          if (resp.status == 200) {
            this.dataObj.appData.charges = resp.data.charges;
            this.dataObj.appData.installmentsData.totalAmount = resp.data.totalAmount;
          }
          else
            this.$alertMsg(resp.data.data.text)
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        }
        ).finally(() => {
          this.dataObj.parent.savingTask = false;
        });
    },
    refreshInstallments() {
      var parameter = {
        ApplicationId: this.dataObj.appId,
        ApplicationKey: this.dataObj.appKey,
        Item: JSON.parse(JSON.stringify(this.dataObj.appData.installmentsData))
      };

      axios.post('/ConnectionFeeCalculatorActivity/RefreshInstallments', parameter)
        .then(response => {
          if (response.status == 200) {
            this.selectedPenaltyType = JSON.parse(JSON.stringify(this.dataObj.appData.installmentsData.penaltyType));
            this.selectedPenaltyValue = JSON.parse(JSON.stringify(this.dataObj.appData.installmentsData.penaltyValue));

            this.dataObj.appData.installmentsData.installments = response.data.items;
            this.installmentDescribe = this.dataObj.appData.installmentsData.chargeSchedule == 1 ? 'cycleNo' : 'chargeDate';

            this.installmentsPenaltyValues = [];

            if (this.selectedPenaltyType != 0) {
              var pv = 0;
              for (var i = 0; i < this.dataObj.appData.installmentsData.installments.length; i++) {
                if (this.selectedPenaltyType == 1) {
                  pv = Number((this.dataObj.appData.installmentsData.installments[i].amount * this.selectedPenaltyValue / 100).toFixed(3));
                } else if (this.selectedPenaltyType == 2) {
                  pv = Number(this.selectedPenaltyValue);
                }

                this.installmentsPenaltyValues.push({
                  value: pv,
                  total: this.dataObj.appData.installmentsData.installments[i].amount + pv
                });
              }
            }
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch(err => {
          this.$alertMsg(err.data);
        }
      );
    },
    prepareInstallments() {
      if (this.dataObj.appData.installmentsData == null)
        return;

      if (this.dataObj.appData.installmentsData.installments.length == 0)
        return;


      this.selectedPenaltyType = JSON.parse(JSON.stringify(this.dataObj.appData.installmentsData.penaltyType));
      this.selectedPenaltyValue = JSON.parse(JSON.stringify(this.dataObj.appData.installmentsData.penaltyValue));

      this.installmentDescribe = this.dataObj.appData.installmentsData.chargeSchedule == 1 ? 'cycleNo' : 'chargeDate';

      this.installmentsPenaltyValues = [];

      if (this.selectedPenaltyType != 0) {
        var pv = 0;
        for (var i = 0; i < this.dataObj.appData.installmentsData.installments.length; i++) {
          if (this.selectedPenaltyType == 1) {
            pv = Number((this.dataObj.appData.installmentsData.installments[i].amount * this.selectedPenaltyValue / 100).toFixed(3));
          } else if (this.selectedPenaltyType == 2) {
            pv = Number(this.selectedPenaltyValue);
          }

          this.installmentsPenaltyValues.push({
            value: pv,
            total: this.dataObj.appData.installmentsData.installments[i].amount + pv
          });
        }
      }
    }
  },
}
